import { Asset, AssetId, AssetDataObject } from "./asset";
import { ConflictClause, DataObject, DateTimeStamps } from "./common";

export type ContentId = number
export type ContentAnnotation = object
export type ContentTitle = string
export type ContentBody = string

enum content_constraint {
  content_pkey= "content_pkey"
}

export interface ContentAsset {
  asset: Asset;
  assetId?: AssetId;
  contentId?: Array<ContentId>;
  createdAt?: DateTimeStamps;
  updatedAt?: DateTimeStamps;
}

export interface ContentAssetDataObject {
  asset?: DataObject<AssetDataObject>
  content?: DataObject<AssetDataObject>
}

export interface Content {
  id?: ContentId
  contentAssets: Array<ContentAsset>
  annotation?: ContentAnnotation
  title: ContentTitle
  body: ContentBody
  createdAt?: DateTimeStamps
  updatedAt?: DateTimeStamps
}

export interface ContentDataObject {
  id?: ContentId
  content_assets: DataObject<Array<ContentAssetDataObject>>
  title: ContentTitle
  body: ContentBody
  annotation: ContentAnnotation
}
